import { render, staticRenderFns } from "./staff-thumb.vue?vue&type=template&id=df5f1710"
import script from "./staff-thumb.vue?vue&type=script&lang=js"
export * from "./staff-thumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports